'use client';

import ExchangeIcon from './Exchange.js';
import AddTagIcon from './AddTag.js';

var FormAction = {
    ExchangeIcon: ExchangeIcon,
    AddTagIcon: AddTagIcon
};

export { FormAction as default };
//# sourceMappingURL=index.js.map
